<template>
  <p class="a-body" :class="[bodySize, bodyAlign]" :style="lineClampStyle">
    <slot />
  </p>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ABody',
  props: {
    size: {
      type: String,
      default: '',
      validator(size) {
        return ['', 'small', 'medium'].includes(size as string);
      }
    },
    align: {
      type: String,
      default: '',
      validator(align) {
        return ['', 'center'].includes(align as string);
      }
    },
    lineClamp: {
      type: Number,
      default: 0
    }
  },
  computed: {
    bodySize() {
      return this.size ? `a-body--size-${this.size}` : '';
    },
    bodyAlign() {
      return this.align ? `a-body--align-${this.align}` : '';
    },
    lineClampStyle() {
      return this.lineClamp > 0
        ? {
            display: '-webkit-box',
            overflow: 'hidden',
            'max-height': 'initial',
            '-webkit-line-clamp': `${this.lineClamp}`,
            '-webkit-box-orient': 'vertical'
          }
        : {};
    }
  }
});
</script>

<style lang="scss" scoped>
.a-body {
  line-height: 1.5;
  font-size: 14px;
  color: #484848;

  &--size-small {
    font-size: 12px;
  }

  &--size-medium {
    font-size: 16px;
  }

  &--type-attention {
    color: #ff6a6a;
  }

  &--align-center {
    text-align: center;
  }

  &--line-clamp {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
}
</style>
